import React from 'react';
import styled from 'styled-components';

const Value = styled.div`
  font-size: 11px;
  letter-spacing: 0.5px;
  line-height: 14px;
  font-weight: 600;
`;

export default Value;
